import api, { type ResponsePayloadWithData } from '../../../api';

export interface LicensedModule {
  id: string;
  name: string;
  niceName: string;
  subModules?: LicensedModule[];
}

export async function fetchLicensedModules(): Promise<LicensedModule[]> {
  const {
    data: { data: licensedModuleData },
  } = await api.get<ResponsePayloadWithData<LicensedModule[]>>(
    `/studio/support/licensed-modules?group=${process.env.REACT_APP_P_STUDIO_GROUP}`,
  );

  return licensedModuleData;
}
